export type OptionalClassName = string | false | null | undefined;

/**
 * Concatenate any truthy {@link classNames}. Useful for conditionally applying classes.
 *
 * @example cn("a", cond && "b")
 */
export function cn(...classNames: OptionalClassName[]) {
    if (classNames.length === 1) {
        const className = classNames[0];
        return typeof className === "string" ? className : "";
    }

    let className = "";
    for (const c of classNames) {
        if (typeof c === "string" && c !== "") {
            className += c;
            className += " ";
        }
    }
    return className;
}

/** Call {@link value} with {@link values} if it is a function, otherwise return it. */
export function runIfFn<T, TV>(value: T | ((values: TV) => T), values: TV): T {
    // `T` may itself be a function, so the `typeof` check does not narrow to the callback.
    return typeof value === "function" ? (value as (values: TV) => T)(values) : value;
}
